export const ENTITY_NAME = 'PERSON_CODE_VALUE_'